import React from 'react'
import '../../stylesheets/BinaryBGSS.css'

function binaryBG({img, cName, styleObj}) {
    return (
        <div id='bin_container' className={cName} style={styleObj.parent}>
            <div id='text' style={styleObj.text}> 
                <p id='bin'>
                    0 1 0 0 0 1 1 1 0 1 1 0 1 1 1 1 0 1 1 0 0 1 
                    0 0 0 0 1 0 0 0 0 0 0 1 1 0 1 0 0 1 0 1 1 1 
                    0 0 1 1 0 0 1 0 0 0 0 0 0 1 1 0 1 1 0 0 0 1 
                    1 0 1 1 1 1 0 1 1 1 0 1 1 0 0 1 1 0 0 1 0 1 
                    0 0 0 0 1 0 1 0 0 1 0 0 1 0 1 0 0 1 1 0 0 1 
                    0 1 0 1 1 1 0 0 1 1 0 1 1 1 0 1 0 1 0 1 1 1 
                    0 0 1 1 0 0 1 0 0 0 0 0 0 1 0 0 0 0 1 1 0 1 
                    1 0 1 0 0 0 0 1 1 1 0 0 1 0 0 1 1 0 1 0 0 1 
                    0 1 1 1 0 0 1 1 0 1 1 1 0 1 0 0 0 0 1 0 0 0 
                    0 0 0 1 0 0 1 1 0 0 0 1 1 0 1 1 1 1 0 1 1 1 
                    0 1 1 0 0 1 1 0 0 1 0 1 0 1 1 1 0 0 1 1 0 0 
                    1 0 0 0 0 0 0 1 1 1 1 0 0 1 0 1 1 0 1 1 1 1 
                    0 1 1 1 0 1 0 1 0 0 0 0 1 0 1 0 0 1 0 0 1 0 
                    1 0 0 1 1 0 0 1 0 1 0 1 1 1 0 0 1 1 0 1 1 1 
                    0 1 0 1 0 1 1 1 0 0 1 1 0 0 1 0 0 0 0 0 0 1 
                    0 0 0 0 1 1 0 1 1 0 1 0 0 0 0 1 1 1 0 0 1 0 
                    0 1 1 0 1 0 0 1 0 1 1 1 0 0 1 1 0 1 1 1 0 1 
                    0 0 0 0 1 0 0 0 0 0 0 1 1 0 1 0 0 1 0 1 1 1 
                    0 0 1 1 0 0 1 0 0 0 0 0 0 1 0 0 1 1 0 0 0 1 
                    1 0 1 1 1 1 0 1 1 1 0 0 1 0 0 1 1 0 0 1 0 0 
                    0 0 0 0 1 0 1 0 0 1 0 1 0 0 1 1 0 1 1 0 1 0 
                    0 0 0 1 1 0 0 0 0 1 0 1 1 0 1 1 0 0 0 1 1 0 
                    1 1 1 1 0 1 1 0 1 1 0 1 0 1 0 0 0 1 1 1 0 1 
                    1 0 1 1 1 1 0 1 1 0 0 1 0 0 0 0 1 0 0 0 0 0 
                    0 1 1 0 1 0 0 1 0 1 1 1 0 0 1 1 0 0 1 0 0 0 
                    0 0 0 1 1 0 1 1 0 0 0 1 1 0 1 1 1 1 0 1 1 1 
                    0 1 1 0 0 1 1 0 0 1 0 1 0 0 0 0 1 0 1 0 0 1 
                    0 0 1 0 1 0 0 1 1 0 0 1 0 1 0 1 1 1 0 0 1 1 
                    0 1 1 1 0 1 0 1 0 1 1 1 0 0 1 1 0 0 1 0 0 0 
                    0 0 0 1 0 0 0 0 1 1 0 1 1 0 1 0 0 0 0 1 1 1 
                    0 0 1 0 0 1 1 0 1 0 0 1 0 1 1 1 0 0 1 1 0 1 
                    1 1 0 1 0 0 0 0 1 0 0 0 0 0 0 1 0 0 1 1 0 0 
                    0 1 1 0 1 1 1 1 0 1 1 1 0 1 1 0 0 1 1 0 0 1 
                    0 1 0 1 1 1 0 0 1 1 0 0 1 0 0 0 0 0 0 1 1 1 
                    1 0 0 1 0 1 1 0 1 1 1 1 0 1 1 1 0 1 0 1 0 0 
                    0 0 1 0 1 0 0 1 0 0 1 0 1 0 0 1 1 0 0 1 0 1 
                    0 1 1 1 0 0 1 1 0 1 1 1 0 1 0 1 0 1 1 1 0 0 
                    1 1 0 0 1 0 0 0 0 0 0 1 0 0 0 0 1 1 0 1 1 0 
                    1 0 0 0 0 1 1 1 0 0 1 0 0 1 1 0 1 0 0 1 0 1 
                    1 1 0 0 1 1 0 1 1 1 0 1 0 0 0 0 1 0 0 0 0 0 
                    0 1 1 0 1 0 0 1 0 1 1 1 0 0 1 1 0 0 1 0 0 0 
                    0 0 0 1 0 0 1 1 0 0 0 1 1 0 1 1 1 1 0 1 1 1 
                    0 0 1 0 0 1 1 0 0 1 0 0 0 0 0 0 1 0 1 0 0 1 
                    0 1 0 0 1 1 0 1 1 0 1 0 0 0 0 1 1 0 0 0 0 1 
                    0 1 1 0 1 1 0 0 0 1 1 0 1 1 1 1 0 1 1 0 1 1 
                    0 1 0 1 0 0 0 1 1 1 0 1 1 0 1 1 1 1 0 1 1 0 
                    0 1 0 0 0 0 1 0 0 0 0 0 0 1 1 0 1 0 0 1 0 1 
                    1 1 0 0 1 1 0 0 1 0 0 0 0 0 0 1 1 0 1 1 0 0 
                    0 1 1 0 1 1 1 1 0 1 1 1 0 1 1 0 0 1 1 0 0 1 
                    0 1 0 0 0 0 1 0 1 0 0 1 0 0 1 0 1 0 0 1 1 0 
                    0 1 0 1 0 1 1 1 0 0 1 1 0 1 1 1 0 1 0 1 0 1 
                    1 1 0 0 1 1 0 0 1 0 0 0 0 0 0 1 0 0 0 0 1 1 
                    0 1 1 0 1 0 0 0 0 1 1 1 0 0 1 0 0 1 1 0 1 0 
                    0 1 0 1 1 1 0 0 1 1 0 1 1 1 0 1 0 0 0 0 1 0 
                    0 0 0 0 0 1 0 0 1 1 0 0 0 1 1 0 1 1 1 1 0 1 
                    1 1 0 1 1 0 0 1 1 0 0 1 0 1 0 1 1 1 0 0 1 1 
                    0 0 1 0 0 0 0 0 0 1 1 1 1 0 0 1 0 1 1 0 1 1 
                    1 1 0 1 1 1 0 1 0 1 0 0 0 0 1 0 1 0 0 1 0 0 
                    1 0 1 0 0 1 1 0 0 1 0 1 0 1 1 1 0 0 1 1 0 1 
                    1 1 0 1 0 1 0 1 1 1 0 0 1 1 0 0 1 0 0 0 0 0 
                    0 1 0 0 0 0 1 1 0 1 1 0 1 0 0 0 0 1 1 1 0 0 
                    1 0 0 1 1 0 1 0 0 1 0 1 1 1 0 0 1 1 0 1 1 1 
                    0 1 0 0 0 0 1 0 0 0 0 0 0 1 1 0 1 0 0 1 0 1 
                    1 1 0 0 1 1 0 0 1 0 0 0 0 0 0 1 0 0 1 1 0 0 
                    0 1 1 0 1 1 1 1 0 1 1 1 0 0 1 0 0 1 1 0 0 1 
                    0 0 0 0 0 0 1 0 1 0 0 1 0 1 0 0 1 1 0 1 1 0 
                    1 0 0 0 0 1 1 0 0 0 0 1 0 1 1 0 1 1 0 0 0 1 
                    1 0 1 1 1 1 0 1 1 0 1 1 0 1
                </p>
            </div>
            <div id='circle' style={styleObj.child}>
                <img src={img} alt='one line drawing'></img>
            </div>
        </div>
    )
}

export default binaryBG